import * as types from "../../constants/AppConstants";

const initialState = {
    isOpen: false
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.MODAL_REDUCER:
            return {
                ...state,
                isOpen: action.payload
            };
        default: {
            return { ...state };
        }
    }
};

export default modalReducer;